import { Box, Typography, Checkbox } from '@mui/material'
import type { TPublisherSong } from '@modules/types'

interface SongItemProps {
  song: TPublisherSong
  isSelected: boolean
  onSelect: (id: number) => void
}

export const SongItem = ({ song, isSelected, onSelect }: SongItemProps) => (
  <Box display="flex" alignItems="center" py={1}>
    <Box flex={1}>
      <Typography fontWeight={500}>{song.clientRequestSong?.writers}</Typography>
      <Typography fontWeight={500}>{song.clientRequestSong?.title}</Typography>
    </Box>
    <Checkbox checked={isSelected} onChange={() => onSelect(song.id)} color="primary" />
  </Box>
)
